import React from "react";
import { SideMenu, BackHeader } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import { GiCheckMark } from "react-icons/gi";
import { useNavigate } from "react-router-dom";
const PurchasesProductMessage = () => {
  const navigate = useNavigate();
  return (
    <SideMenu purchseIcon={true}>
      <div className="page-details-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={4} lg={4} md={12} sm={12} xs={12}>
            </Grid>
            <Grid item xl={4} lg={4} md={12} sm={12} xs={12}>
              <div>
                <div className="purchase-product-message-main">
                  <div className="purchase-product-message-icon">
                    <GiCheckMark color="white" size={50} />
                  </div>
                </div>
                <p className="purchase-product-message-username">
                  samantha aryton
                </p>
                <p className="purchase-product-message-title">
                  Thank you For Order{" "}
                </p>
                <p className="purchase-product-message-date">
                  14 july 2021 by 09:00am{" "}
                </p>
                <Button
                  className="form-button"
                  variant="text"
                  onClick={() => navigate("/purchases-product")}
                >
                  Thank you
                </Button>
              </div>
            </Grid>
            <Grid item xl={4} lg={4} md={12} sm={12} xs={12}></Grid>
          </Grid>
        </Box>
      </div>
    </SideMenu>
  );
};
export default PurchasesProductMessage;
